var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4722 6.17001C19.4722 7.56001 20.8522 9.77001 21.1322 12.32",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0022 12.37C4.2622 9.83 5.6222 7.62 7.6022 6.22",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70215 20.94C9.86215 21.53 11.1821 21.86 12.5721 21.86C13.9121 21.86 15.1721 21.56 16.3021 21.01",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79224 4.92001C9.79224 6.45001 11.0322 7.70001 12.5722 7.70001C14.1122 7.70001 15.3522 6.46001 15.3522 4.92001C15.3522 3.38001 14.1122 2.14001 12.5722 2.14001",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34226 19.92C6.87761 19.92 8.12226 18.6753 8.12226 17.14C8.12226 15.6046 6.87761 14.36 5.34226 14.36C3.8069 14.36 2.56226 15.6046 2.56226 17.14C2.56226 18.6753 3.8069 19.92 5.34226 19.92Z",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4521 17.14C22.4521 15.61 21.2121 14.36 19.6721 14.36C18.1321 14.36 16.8921 15.6 16.8921 17.14C16.8921 18.68 18.1321 19.92 19.6721 19.92",
    stroke: "#E0E0E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ee4badb25ebf69f76d393058ced6274d.svg";
export { ForwardRef as ReactComponent };